import React from 'react'
import "./Core.css"
import coreimage from "../Images/coreimage.png";
import c1 from "../Images/c1.svg";
import c2 from "../Images/c2.svg";
import c3 from "../Images/c3.svg";
import c4 from "../Images/c4.svg";
import c5 from "../Images/c5.svg";
const Core = () => {
    return (
        <div id='core'>
            <div className="section">
                <div className="container">
                    <div className="coreLeft">
                        <h1 className="heading">
                            Our Core Website
                            Development Services
                        </h1>
                        <div className="corecontent">

                            <div className="corebox">
                                {/* first core */}
                                <div className="corediv">
                                    <div className="imagebox">
                                        <img src={c1} alt="c1" className='coreicon' />
                                    </div>
                                    <h3 className='coreh3'>Website Development</h3>
                                    <p className='corep'>Custom-designed responsive websites that reflect your brand and engage your target audience. </p>
                                </div>
                                {/* second core */}
                                <div className="corediv">
                                    <div className="imagebox">
                                        <img src={c2} alt="c1" className='coreicon' />
                                    </div>
                                    <h3 className='coreh3'>E-Commerce Development</h3>
                                    <p className='corep'>Full-scale e-commerce stores with secure payments, product management, and user-friendly design.</p>
                                </div>
                            </div>
                            <div className="corebox">
                                {/* first core */}
                                <div className="corediv">
                                    <div className="imagebox">
                                        <img src={c3} alt="c1" className='coreicon' />
                                    </div>
                                    <h3 className='coreh3'>Web Application Development</h3>
                                    <p className='corep'>Powerful, scalable web apps tailored to your business processes—built for performance and security. </p>
                                </div>
                                {/* second core */}
                                <div className="corediv">
                                    <div className="imagebox">
                                        <img src={c4} alt="c1" className='coreicon' />
                                    </div>
                                    <h3 className='coreh3'>Content Management Systems (CMS)</h3>
                                    <p className='corep'>Flexible CMS solutions (WordPress, Strapi, headless CMS, etc.) for effortless content control.</p>
                                </div>
                            </div>
                            <div className="corebox singlecore">
                                {/* first core */}
                                <div className="corediv">
                                    <div className="imagebox">
                                        <img src={c5} alt="c1" className='coreicon' />
                                    </div>
                                    <h3 className='coreh3'>Low-Code Development</h3>
                                    <p className='corep'>Faster delivery through modern low-code platforms—perfect for startups, MVPs, and fast-moving teams.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="coreRight">
                        <img src={coreimage} alt="coreimage" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Core